import { SUPPORTED_LOCALES } from '../../utils/numberFormat';
import { mapLanguageToLocale } from '../../utils/mapLanguageToLocale';
import { selectors as authSelectors } from '../auth.duck';
import { selectors as i18nSelectors } from '../i18n';

import type { SupportedLocale } from '../../utils/numberFormat';

/**
 * Combined selector that derives the numeric locale from auth + i18n state.
 *
 * Priority:
 *  1. The `locale` field on the authenticated user (whoami), if it is a
 *     supported Intl locale.
 *  2. The app language mapped to a BCP 47 locale via `mapLanguageToLocale`.
 */
export function getLocale(state: unknown): SupportedLocale {
  const whoamiLocale = authSelectors.getUserLocale(state);
  if (whoamiLocale && SUPPORTED_LOCALES.includes(whoamiLocale)) return whoamiLocale;

  const lang = i18nSelectors.getLanguage(state);
  return mapLanguageToLocale(lang);
}
